// ** UI
import IconButton from '@mui/material/IconButton';

// ** Local
import CloseIcon from './CloseIcon';

type LightboxCloseButtonProps = {
	onClick: () => void;
};

const LightboxCloseButton = ({ onClick }: LightboxCloseButtonProps) => (
	<IconButton
		onClick={onClick}
		aria-label="Schließen"
		disableRipple
		sx={{
			width: 48,
			height: 48,
			borderRadius: '8px',
			bgcolor: 'rgba(255,255,255,0.12)',
			color: 'common.white',
			'&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
			'&:focusVisible': {
				outline: '2px solid',
				outlineColor: 'common.white',
				outlineOffset: 2
			}
		}}
	>
		<CloseIcon size={30} />
	</IconButton>
);

export default LightboxCloseButton;
